import { SvgIcon } from "@material-ui/core";
import React from "react";

const PriceIcon = props => (
  <SvgIcon>
    <g id="Icon/PriceIcon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="21"
        fill="none"
        viewBox={props.viewBox}
      >
        <path
          stroke={props.color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.6"
          d="M10.375 19.75a9.375 9.375 0 100-18.75 9.375 9.375 0 100 18.75z"
        />
        <path
          stroke={props.color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.6"
          d="M10.375 10.375A1.872 1.872 0 018.5 8.5c0-1.037.838-1.875 1.875-1.875h1.875M10.375 10.375c1.037 0 1.875.838 1.875 1.875a1.872 1.872 0 01-1.875 1.875H8.5M10.375 4.75v1.875M10.375 14.125V16"
        />
      </svg>
    </g>
  </SvgIcon>
);

export default PriceIcon;



// WEBPACK FOOTER //
// ./src/icons/PriceIcon.jsx